import { IResponse } from "../contracts/IResponse";
import { HttpMethodEnum } from "../enums/enums";
import { Product } from "../models/Product";
import { BaseService } from "./BaseService";

export class ProductService extends BaseService {
    constructor() {
        super("product");
    }

    Prices(storeID:number,ids: string): Promise<IResponse<Product[]>> {
        return fetch(`${this.EndPoint}/prices/${storeID}/${ids}`, { method: HttpMethodEnum.GET, headers:{ "Content-Type": "application/json" }}).then(response => response.json())
    }
}